import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactSelect from "react-select";
import { SelectStyles } from '../../../../styles/global';
import { useTranslation } from 'react-i18next';

const WeekSessionBubbleContent = ({
  optionMonths,
  optionDays
}) => {
  const { control, setValue, formState: { errors }, } = useFormContext();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
    <div className="flex gap-4">
      Selecciona la sesión de la semana que vamos a planear:
    </div>
    <div className="flex w-full gap-2">
      <div className="m-0 w-full  h-full flex flex-col gap-1 justify-between">
        <div>Mes</div>
        <div>
          <Controller
            name="month"
            control={control}
            rules={{ required: t("campo_requerido") }}
            render={({ field }) => (
              <ReactSelect
                {...field}
                options={optionMonths}
                value={
                  optionMonths.find(
                    (option) => option.value === field.value
                  ) || null
                }
                placeholder={"Selecciona un mes"}
                onChange={(option) => {
                  const newValue = option
                    ? option.value
                    : null;
                  setValue("formaLectura", newValue);
                  field.onChange(newValue);
                }}
                styles={SelectStyles}
                isMulti={false}
                maxMenuHeight={400}
                menuPlacement="bottom"
              />
            )}
          />
          {errors.month && (
            <span className="input-error">
              {errors.month.message}
            </span>
          )}
        </div>
      </div>

      <div className="m-0 w-full h-full flex flex-col gap-1 justify-between">
        <div>Día</div>
        <div>
          <Controller
            name="day"
            control={control}
            rules={{ required: t("campo_requerido") }}
            render={({ field }) => (
              <ReactSelect
                {...field}
                options={optionDays}
                value={
                  optionDays.find(
                    (option) => option.value === field.value
                  ) || null
                }
                placeholder={"Selecciona un dia"}
                onChange={(option) => {
                  const newValue = option
                    ? option.value
                    : null;
                  setValue("formaLectura", newValue);
                  field.onChange(newValue);
                }}
                styles={SelectStyles}
                isMulti={false}
                maxMenuHeight={400}
                menuPlacement="bottom"
              />
            )}
          />
          {errors.day && (
            <span className="input-error">
              {errors.day.message}
            </span>
          )}
        </div>
      </div>
    </div>
  </div>
  );
};

export default WeekSessionBubbleContent;
